export default "__VITE_ASSET__0ab0e4e7__"